import { jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { ServiceIconShell } from '../ServiceIconShell/ServiceIconShell.es.js';

const PDLFontMap = (iconSize, collapsedIconCount) => {
  switch (iconSize) {
    case "small":
      return "--zds-small-print-3";
    case "medium":
    case "large":
      return collapsedIconCount <= 9 ? "--zds-paragraph-header-3" : "--zds-body-3";
    default:
      return "--zds-paragraph-header-3";
  }
};
const Styles = labelStyles("ServiceIconNumeric", {
  number: (iconSize, collapsedIconCount) => ({
    color: "var(--zds-text-default)",
    textIndent: "var(--zds-space-0)",
    // Optical alignment
    font: `var(${PDLFontMap(iconSize, collapsedIconCount)})`
  })
});
const ServiceIconNumeric = (props) => {
  const { size, hasBorder = true, hasWhiteBackground } = props;
  const label = `Plus ${props.number} more apps.`;
  const text = props.number > 99 ? `99+` : `+${props.number}`;
  return jsx(
    ServiceIconShell,
    { size, hasBorder, hasWhiteBackground },
    jsx(
      "span",
      { "aria-label": label, css: Styles.number(size, props.number), role: "img", "data-zds": true },
      jsx("span", { "aria-hidden": "true", "data-zds": true }, text)
    )
  );
};

export { ServiceIconNumeric };
//# sourceMappingURL=ServiceIconNumeric.es.js.map
